<template>
  <div class="headerLogin">
    <ul class="clearfix">
      <li class="fr flag" v-show="showLang">
        <el-dropdown id="lang" trigger="click" :hide-on-click="false" @command="langCommand" data-testid="dropdownFlag">
          <div class="login_inner">
            <div v-if="lang == 'ar' || lang == 'fa'" class="flex items-center justify-end gap-2.5">
              <img :src="language.icon" alt class="member_logo" />
              <span class="text-blackG0 lg:text-white">{{ language.label }}</span>
              <img class="down hidden lg:block" src="@/assets/images/icon_caret_bottom_white.png" alt />
              <img class="down lg:hidden" src="@/assets/images/icon_caret_bottom.png" alt />
            </div>
            <div v-else class="flex items-center justify-end gap-2.5">
              <img :src="language.icon" alt class="member_logo" />{{ language.label }}
              <img :src="caretImg" alt class="down" />
            </div>
          </div>
          <el-dropdown-menu slot="dropdown" class="lang_dropdown_box" placement="right-end">
            <el-dropdown-item
              v-for="item in languages"
              :key="item.value"
              :command="item"
              :class="{ active: lang == item.value }"
              :data-testid="item.value"
            >
              <img :src="item.icon" />
              <span>{{ item.label }}</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </li>
    </ul>
  </div>
</template>

<script>
import { sensorsRegister } from '@/util/sensorsdata';
import { RTL_LANGUAGE_LIST } from '@/constants/language.js';
import { loadDownloadI18n } from '@/resource/i18n';
import { setLocale } from '@/util/i18n';

export default {
  name: 'HeaderLogin',
  data() {
    return {
      showLang: true,
      language: '',
      languages: [
        {
          value: 'en_US',
          label: 'English',
          icon: require('@/assets/images/flag/uk_flag.png')
        },
        {
          value: 'zh_CN',
          label: '中文简体',
          icon: require('@/assets/images/flag/cn_flag.png')
        },
        {
          value: 'zh_TW',
          label: '中文繁體',
          icon: require('@/assets/images/flag/hk_flag.png')
        },
        {
          value: 'fr_FR',
          label: 'Français',
          icon: require('@/assets/images/flag/fr_flag.png')
        },
        {
          value: 'ko',
          label: '한국어',
          icon: require('@/assets/images/flag/ko_flag.png')
        },
        {
          value: 'ja',
          label: '日本語',
          icon: require('@/assets/images/flag/ja_flag.png')
        },
        {
          value: 'th',
          label: 'ภาษาไทย',
          icon: require('@/assets/images/flag/th_flag.png')
        },
        {
          value: 'vi',
          label: 'Tiếng Việt',
          icon: require('@/assets/images/flag/vi_flag.png')
        },
        {
          value: 'es',
          label: 'Español',
          icon: require('@/assets/images/flag/es_flag.png')
        },
        {
          value: 'pt',
          label: 'Português',
          icon: require('@/assets/images/flag/pt_flag.png')
        },
        {
          value: 'de',
          label: 'Deutsch',
          icon: require('@/assets/images/flag/de_flag.png')
        },
        {
          value: 'id',
          label: 'Indonesian',
          icon: require('@/assets/images/flag/id_flag.png')
        },
        {
          value: 'ar',
          label: 'عربي',
          icon: require('@/assets/images/flag/ar_flag.png')
        },
        {
          value: 'pl',
          label: 'Polski',
          icon: require('@/assets/images/flag/pl_flag.png')
        },
        {
          value: 'it',
          label: 'Italian',
          icon: require('@/assets/images/flag/it_flag.png')
        },
        {
          value: 'fa',
          label: 'فارسی',
          icon: require('@/assets/images/flag/fa_flag.png')
        },
        {
          value: 'hi',
          label: 'हिंदी',
          icon: require('@/assets/images/flag/hi_flag.png')
        },
        {
          value: 'ru',
          label: 'Русский',
          icon: require('@/assets/images/flag/ru_flag.png')
        }
      ],
      specificUrlLanguageSetting: [
        {
          url: 'myaccount.vtmarketsindo.com',
          lang: 'id'
        },
        {
          url: 'myaccount.securevtmarketscn.com',
          lang: 'zh_CN'
        },
        {
          url: 'myaccount.vtmarketstrade.com',
          lang: 'zh_CN'
        }
      ],
      caretImg: '',
      openImg: false,
      hostName: location.hostname
    };
  },
  watch: {
    language(lang) {
      this.lang = lang.value;
    },
    lang: {
      immediate: true,
      handler(val) {
        setLocale(val);
        document.body.dir = RTL_LANGUAGE_LIST.includes(val) ? 'rtl' : 'ltr';
        // 如果找不到預設第一筆
        this.language = this.languages.find(f => f.value == val) || this.languages[0];
        this.setFontFamily(val);
        this.caretImg =
          val === 'ar' || val === 'fa'
            ? require('@/assets/images/icon_caret_bottom_white.png')
            : require('@/assets/images/icon_caret_bottom.png');

        sensorsRegister({ current_lang: val });
        try {
          zE('messenger:set', 'locale', this.$options.filters.zendeskLangSwitch(val));
        } catch (error) {
          console.log('zendesk not found', error);
        }
      }
    },
    $route: {
      handler(route) {
        this.showLang = route.meta.restrictLang ? false : true;
      },
      immediate: true
    }
  },
  computed: {
    lang: {
      get() {
        return this.$store.state.common.lang;
      },
      set(value) {
        return this.$store.commit('common/setLang', value);
      }
    },
    isWantAutoSetLangByHostName: {
      get() {
        return sessionStorage.getItem('isWantAutoSetLangByHostName');
      },
      set(value) {
        return sessionStorage.setItem('isWantAutoSetLangByHostName', value);
      }
    }
  },
  methods: {
    langCommand(command) {
      this.language = command;
      //see if language is changed in the landing page
      if (!this.loginStatus) {
        this.$store.commit('common/setIsChangedLangAtLandingPage', true);
      }
    },
    setFontFamily(lang) {
      if (lang == 'ja') {
        document.body.style.setProperty('font-family', 'NotoSansCJKJapanese', 'important');
      } else if (lang == 'zh_CN') {
        document.body.style.setProperty('font-family', 'NotoSansCJKSimChinese', 'important');
      } else if (lang == 'ko') {
        document.body.style.setProperty('font-family', 'NotoSansCJKKorean', 'important');
      } else if (lang == 'vi') {
        document.body.style.setProperty('font-family', 'NotoSansRegular', 'important');
      } else {
        document.body.style.setProperty('font-family', 'Oblivian', 'important');
      }
    },
    autoChangeLangByHostName() {
      if (this.hostName.includes('myaccount.vtmarketsiq.com')) {
        // Follow browser language
        const lang = this.getBrowserLanguage();
        const language = this.languages.find(langObj => langObj.value.split('_')[0] === lang);
        if (language) {
          this.langCommand(language);
        }
      } else {
        for (const { lang, url } of this.specificUrlLanguageSetting) {
          if (this.hostName.includes(url)) {
            const language = this.languages.find(langObj => langObj.value === lang);
            this.langCommand(language);
          }
        }
      }
    },
    getBrowserLanguage() {
      const language = navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language;
      // Return only the language code (en)
      return language.split('-')[0];
    }
  },
  mounted() {
    if (this.isWantAutoSetLangByHostName === 'true' || this.isWantAutoSetLangByHostName === null) {
      this.autoChangeLangByHostName();
      this.isWantAutoSetLangByHostName = false;
    }

    onbeforeunload = () => {
      this.isWantAutoSetLangByHostName = true;
    };

    let callback = (val, oldVal, uri) => {
      if (val != this.userName) location.reload();
    };

    this.$ls.on('setUserName', callback); //watch change foo key and triggered callback
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/layout/headerLogin.scss';
</style>
